import { useSearchParams } from 'react-router-dom'
import { detectLang, t } from '../lib/i18n'
import { FeedbackForm } from '../components/feedback-form'
import type { FeedbackInput } from '../lib/validate'

const VALID_TYPES = ['lesson', 'course', 'doc'] as const
function parseType(v: string | null): FeedbackInput['type'] {
  return VALID_TYPES.includes(v as (typeof VALID_TYPES)[number])
    ? (v as FeedbackInput['type'])
    : 'doc'
}

export function FeedbackPage() {
  const [params] = useSearchParams()
  const lang = detectLang(params)
  const type = parseType(params.get('type'))
  // Slug fallback `general` lets users submit platform-wide feedback when the
  // form is opened without a context (e.g., footer link).
  const slug = params.get('slug')?.trim() || 'general'

  return (
    <section className="mx-auto max-w-prose">
      <h1 className="text-3xl font-semibold tracking-tight text-text">
        {t(lang, 'feedback.title')}
      </h1>
      <p className="mt-3 text-text-muted">{t(lang, 'feedback.subtitle')}</p>
      {slug !== 'general' && (
        <p className="mt-4 rounded-md bg-bg-muted px-3 py-2 text-sm text-text-muted">
          {t(lang, 'feedback.context')}{' '}
          <span className="font-medium text-text">
            {type}/{slug}
          </span>
        </p>
      )}
      <div className="mt-6">
        <FeedbackForm lang={lang} type={type} slug={slug} />
      </div>
    </section>
  )
}
